import axios from 'axios';

// 创建axios实例
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '',
  timeout: 15000
});

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 不再打印签名信息
    return config;
  },
  error => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data;
    // 判断签名是否验证通过
    if (res.code === '0001' && res.message && res.message.includes('签名')) {
      console.error('签名验证失败:', res);
    }
    return response;
  },
  error => {
    console.error('响应错误:', error);
    return Promise.reject(error);
  }
);

export default request; 